import { getPasswordResetRedirectUrl } from '@lightning/services/auth';

const HOWIE_WEB_ORIGIN = 'https://howie.lightningstudios.ai';

export const getHowiePasswordResetRedirectUrl = () =>
  getPasswordResetRedirectUrl('/reset-password', { origin: HOWIE_WEB_ORIGIN });
